"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AnalyticsService = void 0;
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var AnalyticsService = /*#__PURE__*/function () {
  function AnalyticsService(config) {
    _classCallCheck(this, AnalyticsService);
    this.TAGGING_ID_PREFIX = 'GUIDING_SELLING_WIDGET';
    this.IS_TAGGING_ENABLED = config.enableTealiumTagging !== undefined ? config.enableTealiumTagging : false;
  }
  _createClass(AnalyticsService, [{
    key: "startJourney",
    value: function startJourney() {
      console.log('Journey started');
    }
  }, {
    key: "_composeTaggingViewEvent",
    value: function _composeTaggingViewEvent(_ref) {
      var pageName = _ref.pageName,
        eventLabel = _ref.eventLabel,
        stepIndex = _ref.stepIndex;
      return {
        taggingId: "".concat(this.TAGGING_ID_PREFIX, "_").concat(stepIndex),
        taggingType: 'view',
        page_name: this._composeTaggingPageName(pageName),
        event_category: 'tools',
        event_label: eventLabel || "step".concat(stepIndex)
      };
    }
  }, {
    key: "_composeTaggingActionEvent",
    value: function _composeTaggingActionEvent(_ref2) {
      var pageName = _ref2.pageName,
        eventLabel = _ref2.eventLabel,
        stepIndex = _ref2.stepIndex;
      return _objectSpread(_objectSpread({}, this._composeTaggingViewEvent({
        pageName: pageName,
        eventLabel: eventLabel,
        stepIndex: stepIndex
      })), {}, {
        taggingType: 'link',
        event_category: 'users',
        event_name: 'ui_interaction',
        event_action: 'click'
      });
    }
  }, {
    key: "_composeTaggingActionLinkName",
    value: function _composeTaggingActionLinkName(_ref3) {
      var prefix = _ref3.prefix,
        action = _ref3.action;
      return "".concat(prefix, ":").concat(action);
    }
  }, {
    key: "_composeTaggingPageName",
    value: function _composeTaggingPageName(suffix) {
      return "".concat(this.TAGGING_ID_PREFIX, ":").concat(suffix);
    }

    /**
     * Compose Tealium tagging events payload based on app lifecycle
     * use "_composeTaggingViewEvent", "_composeTaggingActionEvent" and "_composeTaggingActionLinkName" to overwrite and compose events types for children classes
     * @param {Object} context event payload data
     * @param {String} context.pageName page name composed for the current action (e.g PAGE_NAME:solutions tool:result:TAB_NAME)
     * @param {String} context.eventLabel The event label
     * @param {String} context.stepIndex current step (question) index (-1 for last one)
     */
  }, {
    key: "composeTaggingEvents",
    value: function composeTaggingEvents(_ref4) {
      var pageName = _ref4.pageName,
        eventLabel = _ref4.eventLabel,
        stepIndex = _ref4.stepIndex;
      var eventViewTag = this._composeTaggingViewEvent({
        pageName: pageName,
        eventLabel: eventLabel,
        stepIndex: stepIndex
      });
      var eventActionTag = this._composeTaggingActionEvent({
        pageName: pageName,
        eventLabel: eventLabel,
        stepIndex: stepIndex
      });
      return {
        onToolStart: _objectSpread(_objectSpread({}, eventViewTag), {}, {
          event_name: 'tool_start'
        }),
        onToolView: _objectSpread(_objectSpread({}, eventViewTag), {}, {
          event_name: 'tool_view'
        }),
        onToolNext: _objectSpread(_objectSpread({}, eventActionTag), {}, {
          link_name: this._composeTaggingActionLinkName({
            prefix: pageName,
            action: 'Next'
          })
        }),
        onToolBack: _objectSpread(_objectSpread({}, eventActionTag), {}, {
          link_name: this._composeTaggingActionLinkName({
            prefix: pageName,
            action: 'Back'
          })
        }),
        onToolRestart: _objectSpread(_objectSpread({}, eventActionTag), {}, {
          link_name: this._composeTaggingActionLinkName({
            prefix: pageName,
            action: 'Restart'
          })
        }),
        onToolEnd: _objectSpread(_objectSpread({}, eventViewTag), {}, {
          event_name: 'tool_end'
        }),
        onToolResult: _objectSpread(_objectSpread({}, eventViewTag), {}, {
          event_label: 'result',
          event_name: 'tool_success'
        }),
        onToolShare: _objectSpread(_objectSpread({}, eventActionTag), {}, {
          link_name: this._composeTaggingActionLinkName({
            prefix: pageName,
            action: 'Share'
          })
        }),
        onToolCheckout: _objectSpread(_objectSpread({}, eventActionTag), {}, {
          link_name: this._composeTaggingActionLinkName({
            prefix: pageName,
            action: 'Checkout'
          })
        })
      };
    }
  }, {
    key: "endJourney",
    value: function endJourney(_ref5) {
      var handsetProductName = _ref5.handsetProductName,
        planProductName = _ref5.planProductName,
        upsoldProductNames = _ref5.upsoldProductNames,
        broadbandProductName = _ref5.broadbandProductName;
      console.log("Journey ended, selected handset product name ".concat(handsetProductName, ", plan product name ").concat(planProductName, ", upsold product names ").concat(upsoldProductNames, ", broadband product name ").concat(broadbandProductName));
    }
  }]);
  return AnalyticsService;
}();
exports.AnalyticsService = AnalyticsService;